/**
 * Feature switches for the downloadable HTML report.
 *
 * brsr - adds the BRSR content: Scope 3 category coverage, targets and reduction actions,
 *        BRSR Principle 6 indicators, data gaps and the BRSR data completeness tile.
 *        Set to true to include it; the report title and file name follow this switch.
 */
export const HTML_REPORT_FEATURES = {
  brsr: false,
};
